module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "background-loader"
  }, [_c('div', {
    staticClass: "preloader",
    attrs: {
      "aria-busy": "true",
      "aria-label": _vm.$t('application.messages.loading'),
      "data-test": "loading",
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.$t('application.messages.loading'))), _vm._m(0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ellipsis-anim"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-467117bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/loader/components/page-loader.vue
// module id = 766
// module chunks = 1